const u = require('universalify').fromCallback
module.exports = {
  copy: u(require('./copy'))
}



//////////////////
// WEBPACK FOOTER
// ./~/swarm-js/~/fs-extra/lib/copy/index.js
// module id = 1767
// module chunks = 0 1 3